import {styled} from "@mui/material";

export const UserActionbarContainer = styled('div')(() => {
    return {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    }
});

export const UserActionbarButtonsContainer = styled('div')(() => {
    return {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        gap: '1rem'
    }
});
